import AbstractField from "./abstract";

class EmailField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input',
                actions: {
                    'input': this.changed.bind(this)
                }
            },
        }
    }
    __init(){
        
    }
    changed(){
        this.dispatchEvent('changed')
    }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.value !== ''
    }
    getValue(){
        return this.dom.input.value
    }
}


export default EmailField